"use client";

import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";

/**
 * Retry affordance for the generic error branch. The label is passed in because the
 * surrounding error components are server components that already hold the translations.
 *
 * Note: this deliberately does NOT call `window.stop()` on mount (the previous
 * company-error HomeButton did). That aborts every in-flight request on the page,
 * including CookieClearCheck's recovery probe.
 */
const RetryButton = ({ label }: { label: string }) => (
  <CustomButton
    type={BtnTypes.primary}
    size={BtnSizes.medium}
    radius={BtnRadius.medium}
    onClick={() => (window.location.href = "/")}
  >
    {label}
  </CustomButton>
);

export default RetryButton;
